import { parse } from 'date-fns'

import { ApiGetResponse, ApiRequest } from 'app/common/types'

interface DatePeriodGetContent {
  fromDate: string
  toDate: string
}

interface AudienceDayRevenueEntity {
  date: string
  totalRevenue: number
  totalRevenue30DaysBefore: number
  revenueBySignal: [
    {
      id: string
      name: string
      revenue: number
    },
  ]
}

export type AudienceRevenueGetRequest = ApiRequest<DatePeriodGetContent>
export type AudienceRevenueResponse = ApiGetResponse<AudienceDayRevenueEntity[]>

export type AudienceDayRevenue = {
  id: string
  name: string
  revenue: number
}

export type AudiencesDayRevenue = {
  date: Date
  total: number
  total30DaysBefore: number
  audiences: AudienceDayRevenue[]
}

const mapToAudienceDayRevenue = (
  audienceEntity: AudienceDayRevenueEntity,
): AudiencesDayRevenue => ({
  date: parse(audienceEntity.date, 'yyyy-MM-dd', new Date()),
  total: audienceEntity.totalRevenue,
  total30DaysBefore: audienceEntity.totalRevenue30DaysBefore,
  audiences: audienceEntity.revenueBySignal,
})

export const mapToSortedAudienceDayRevenues = (
  audienceDayRevenueEntities: AudienceDayRevenueEntity[],
): AudiencesDayRevenue[] =>
  audienceDayRevenueEntities
    .map(mapToAudienceDayRevenue)
    .sort((a, b) => b.date.getTime() - a.date.getTime())
